import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { PeppolAPTestbedValidationTestFileHelperContainerModel } from '../../../../../../models/aggregates/e-invoice/peppol/bl_ppl_ap_validation_test_file_zip_helper.model';
import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../../shared/api-response.model';
@Injectable({
  providedIn: 'root'
})
export class RunCheckingAndSendValidDocsService extends BaseApiTemplateService<PeppolAPTestbedValidationTestFileHelperContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'ppl/ap/validation-test-file-helper'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'ppl/ap/validation-test-file-helper'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'ppl/ap/validation-test-file-helper'
    this.httpClient = http;
  }

  runChecking(validation_test_file_zip_hdr_guid: string, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + `/run-checking/${validation_test_file_zip_hdr_guid}/backoffice-ep`
    }
  
    // Get the headers from getHttpHeader
    const httpOptions = this.getHttpHeader(visa);
  
    // Add the Content-Type header
    httpOptions.headers = httpOptions.headers.set('Content-Type', 'application/json');
  
    return this.httpClient.get<ApiResponseModel<any>>(
      customUrl,
      httpOptions
    );
  }

  validateDocumentOneByOne(docType : string,dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + "/validate-document-one-by-one/backoffice-ep?docType=" + docType;
    }

    const httpOptions = this.getHttpHeader(visa);

    httpOptions.headers = httpOptions.headers.set('Content-Type', 'application/json');

    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      httpOptions
    );
  }


  
  sendAllValidXML(accesspoint_id : string,validation_test_file_zip_hdr_guid: string, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + `/send-all/${validation_test_file_zip_hdr_guid}/backoffice-ep?accesspoint_id=` + accesspoint_id;
    }
  
    // Get the headers from getHttpHeader
    const httpOptions = this.getHttpHeader(visa);
  
    // Add the Content-Type header
    httpOptions.headers = httpOptions.headers.set('Content-Type', 'application/json');
  
    return this.httpClient.get<ApiResponseModel<any>>(
      customUrl,
      httpOptions
    );
  }

  sendOneByOne(accesspoint_id : string, file_guid: string, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + `/send-valid-one/${file_guid}/backoffice-ep?accesspoint_id=` + accesspoint_id;
    }
  
    // Get the headers from getHttpHeader
    const httpOptions = this.getHttpHeader(visa);
  
    // Add the Content-Type header
    httpOptions.headers = httpOptions.headers.set('Content-Type', 'application/json');
  
    return this.httpClient.get<ApiResponseModel<any>>(
      customUrl,
      httpOptions
    );
  }


}
